import { number, object } from 'yup';
import { getTranslation } from '../../../../../../../components/localization/customHooks/Translation';

const l10n = getTranslation();

const schema = object().shape({
  status: number().required(l10n.components.error.EMPTY_FIELD_ERROR),
});

export default schema;
